// React Core
import React, { useState, useEffect } from 'react';
// Material-UI Core Components
import {
    Typography,
    Box,
    TextField,
    MenuItem,
    Switch,
    FormControlLabel,
    Divider,
    Paper,
    Button,
    Collapse,
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { getReadonlyFlag } from '../../utils/getRoleToken'
import Sidebar from '../Sidebar';
import SendIcon from '@mui/icons-material/Send';

// NOVO: imports para chamada de API, seguindo GaleriaImagensProduto
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const Parametros = () => {
    const readonly = getReadonlyFlag() === true;

    const [etapaAtendimento, setEtapaAtendimento] = useState('');
    const [etapaQualificado, setEtapaQualificado] = useState('');
    const [filaQualificado, setFilaQualificado] = useState(null);
    const [tagQualificado, setTagQualificado] = useState('');
    const [etapaDescartado, setEtapaDescartado] = useState('');
    const [filaDescartado, setFilaDescartado] = useState(null);
    const [tagDescartado, setTagDescartado] = useState('');
    // SEPARADO: número de tentativas x etapa de descarte da cadência
    const [numeroTentativas, setNumeroTentativas] = useState('');
    const [etapaCadenciaDescartado, setEtapaCadenciaDescartado] = useState('');
    const [filaCadenciaGeral, setFilaCadenciaGeral] = useState('');
    const [tagCadencia, setTagCadencia] = useState('');
    const [etapaWhatsApp, setEtapaWhatsApp] = useState('');
    const [tagWhatsApp, setTagWhatsApp] = useState('');

    const [agendarVisitaCrm, setAgendarVisitaCrm] = useState(false); // ADICIONAR

    // NOVO: estados para dados vindos da API
    const [workflows, setWorkflows] = useState([]); // Etapas
    const [filas, setFilas] = useState([]);         // Filas

    // Estados para controlar a expansão de cada seção
    const [expandidoAtendimento, setExpandidoAtendimento] = useState(false);
    const [expandidoQualificacao, setExpandidoQualificacao] = useState(false);
    const [expandidoDescarte, setExpandidoDescarte] = useState(false);
    const [expandidoCadencia, setExpandidoCadencia] = useState(false);
    const [expandidoWhatsApp, setExpandidoWhatsApp] = useState(false);

    // Estados para controlar se houve mudanças
    const [mudancasAtendimento, setMudancasAtendimento] = useState(false);
    const [mudancasQualificacao, setMudancasQualificacao] = useState(false);
    const [mudancasDescarte, setMudancasDescarte] = useState(false);
    const [mudancasCadencia, setMudancasCadencia] = useState(false);
    const [mudancasWhatsApp, setMudancasWhatsApp] = useState(false);
    const [mudancasAgendarVisita, setMudancasAgendarVisita] = useState(false);

    const [dialogSalvarOpen, setDialogSalvarOpen] = useState(false);
    const [salvandoParametro, setSalvandoParametro] = useState(false);
    const [justificativaSalvar, setJustificativaSalvar] = useState("");
    const [secaoAtual, setSecaoAtual] = useState("");

    const [produtos, setProdutos] = useState([]);
    const [isLoadingProdutos, setIsLoadingProdutos] = useState(false);
    const [filasPorProduto, setFilasPorProduto] = useState({});

    const [erroTagQualificado, setErroTagQualificado] = useState(false);
    const [erroTagDescartado, setErroTagDescartado] = useState(false);
    const [erroTagCadencia, setErroTagCadencia] = useState(false);
    const [erroTagWhatsApp, setErroTagWhatsApp] = useState(false);

    const [isLoadingConfiguracoes, setIsLoadingConfiguracoes] = useState(true);

    const openDialogSalvar = () => {
        if (typeof document !== 'undefined') {
            const activeElement = document.activeElement;
            if (activeElement && typeof activeElement.blur === 'function') {
                activeElement.blur();
            }
        }
        setDialogSalvarOpen(true);
    };

    const snakeCase = string => {
        return string
            .replace(/\W+/g, "_")
    };


    const validarTag = (valor) => {
        // Regex para detectar espaços ou caracteres especiais (exceto underscore)
        const caracteresInvalidos = /[^a-zA-Z0-9_]/g;
        return caracteresInvalidos.test(valor);
    };

    // Estados para armazenar valores iniciais
    const [valoresIniciais, setValoresIniciais] = useState({});

    const [idCRM, setIdCRM] = useState(null);

    // Opções para número de tentativas (ex.: 1 a 5)
    const cadenciaOptions = Array.from({ length: 5 }, (_, i) => i + 1);

    // baseURL igual na GaleriaImagensProduto
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // NOVO: efeito para buscar configurações no backend
    useEffect(() => {
        const fetchConfiguracoes = async () => {
            setIsLoadingConfiguracoes(true);
            try {
                const token = localStorage.getItem('jwtToken');
                if (!token) {
                    console.error("Token não encontrado no localStorage.");
                    return;
                }

                const decodedToken = jwtDecode(token);
                const idClienteAipim = decodedToken.id_cliente;

                const response = await axios.get(
                    `${baseURL}/produto/sdr/parametros`,
                    {
                        params: { idClienteAipim },
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                const { sdrConfig, workflows, filas } = response.data || {};

                setWorkflows(workflows || []);
                setFilas(filas || []);

                if (sdrConfig) {
                    // Atendimento
                    setEtapaAtendimento(sdrConfig.idSituacaoCvAiLaura ?? '');

                    // Qualificação
                    setEtapaQualificado(sdrConfig.idSituacaoCvQualificado ?? '');
                    setFilaQualificado(sdrConfig.idFilaCvQualifica);
                    setTagQualificado(sdrConfig.tagCvQualificado ?? '');

                    // Descarte
                    setEtapaDescartado(sdrConfig.idSituacaoCvDescarte ?? '');
                    setFilaDescartado(sdrConfig.idFilaCvDescarte);
                    setTagDescartado(sdrConfig.tagCvDescarte ?? '');

                    // Cadência
                    setNumeroTentativas(sdrConfig.ncadencias ?? '');
                    setEtapaCadenciaDescartado(sdrConfig.idSituacaoCvDescarteCadencia ?? '');
                    setFilaCadenciaGeral(sdrConfig.idFilaCvDescarteCadencia);
                    setTagCadencia(sdrConfig.tagCvDescarteCadencia ?? '');

                    // Números que não são WhatsApp
                    setEtapaWhatsApp(sdrConfig.idSituacaoCvNaoWhatsapp ?? '');
                    setTagWhatsApp(sdrConfig.tagCvNaoWhatsapp ?? '');
                    setAgendarVisitaCrm(sdrConfig.agendarVisitaCrm ?? false);

                    // Após definir todos os valores com setSomething(), adicione:
                    setValoresIniciais(prev => ({
                        ...prev, // mantém filasPorProduto se já tiver vindo do fetchProdutos
                        etapaAtendimento: sdrConfig.idSituacaoCvAiLaura ?? '',
                        etapaQualificado: sdrConfig.idSituacaoCvQualificado ?? '',
                        filaQualificado: sdrConfig.idFilaCvQualifica,
                        tagQualificado: sdrConfig.tagCvQualificado ?? '',
                        etapaDescartado: sdrConfig.idSituacaoCvDescarte ?? '',
                        filaDescartado: sdrConfig.idFilaCvDescarte,
                        tagDescartado: sdrConfig.tagCvDescarte ?? '',
                        numeroTentativas: sdrConfig.ncadencias ?? '',
                        etapaCadenciaDescartado: sdrConfig.idSituacaoCvDescarteCadencia ?? '',
                        filaCadenciaGeral: sdrConfig.idFilaCvDescarteCadencia,
                        tagCadencia: sdrConfig.tagCvDescarteCadencia ?? '',
                        etapaWhatsApp: sdrConfig.idSituacaoCvNaoWhatsapp ?? '',
                        tagWhatsApp: sdrConfig.tagCvNaoWhatsapp ?? '',
                        agendarVisitaCrm: sdrConfig.agendarVisitaCrm ?? false,
                    }));
                }
            } catch (error) {
                console.error("Erro ao buscar configurações de Leads:", error);
            } finally {
                setIsLoadingConfiguracoes(false);
            }
        };

        if (baseURL) {
            fetchConfiguracoes();
        }
    }, [baseURL]);

    useEffect(() => {
        const contratosAtivos = localStorage.getItem('contratosAtivos');
        if (contratosAtivos) {
            try {
                const contratos = JSON.parse(contratosAtivos);
                const contratoSDR = contratos.find(c => c.idProduto === 2);
                if (contratoSDR) {
                    setIdCRM(contratoSDR.idCRM);
                }
            } catch (error) {
                console.error("Erro ao parsear contratosAtivos:", error);
            }
        }
    }, []);

    // Detectar mudanças em Atendimento
    useEffect(() => {
        if (valoresIniciais.etapaAtendimento !== undefined) {
            setMudancasAtendimento(etapaAtendimento !== valoresIniciais.etapaAtendimento);
        }
    }, [etapaAtendimento, valoresIniciais.etapaAtendimento]);

    // Detectar mudanças Em Atendimento
    useEffect(() => {
        if (valoresIniciais.etapaQualificado !== undefined) {
            const mudou =
                etapaQualificado !== valoresIniciais.etapaQualificado ||
                filaQualificado !== valoresIniciais.filaQualificado ||
                tagQualificado !== valoresIniciais.tagQualificado;
            setMudancasQualificacao(mudou);
        }
    }, [etapaQualificado, filaQualificado, tagQualificado, valoresIniciais]);

    // Detectar mudanças em Descarte
    useEffect(() => {
        if (valoresIniciais.etapaDescartado !== undefined) {
            const mudou =
                etapaDescartado !== valoresIniciais.etapaDescartado ||
                filaDescartado !== valoresIniciais.filaDescartado ||
                tagDescartado !== valoresIniciais.tagDescartado;
            setMudancasDescarte(mudou);
        }
    }, [etapaDescartado, filaDescartado, tagDescartado, valoresIniciais]);

    // Detectar mudanças em Cadência
    useEffect(() => {
        if (valoresIniciais.numeroTentativas !== undefined) {
            const mudouCamposGerais =
                numeroTentativas !== valoresIniciais.numeroTentativas ||
                etapaCadenciaDescartado !== valoresIniciais.etapaCadenciaDescartado ||
                filaCadenciaGeral !== valoresIniciais.filaCadenciaGeral ||
                tagCadencia !== valoresIniciais.tagCadencia;

            const iniciaisFilas = valoresIniciais.filasPorProduto;
            const atuaisFilas = filasPorProduto || {};

            // Se ainda não temos snapshot inicial das filas, não considerar mudança de produto
            let mudouFilasProdutos = false;
            if (iniciaisFilas) {
                mudouFilasProdutos =
                    JSON.stringify(iniciaisFilas) !== JSON.stringify(atuaisFilas);
            }


            setMudancasCadencia(mudouCamposGerais || mudouFilasProdutos);
        }
    }, [numeroTentativas, etapaCadenciaDescartado, filaCadenciaGeral, tagCadencia, filasPorProduto, valoresIniciais]);

    // Detectar mudanças em WhatsApp
    useEffect(() => {
        if (valoresIniciais.etapaWhatsApp !== undefined) {
            const mudou =
                etapaWhatsApp !== valoresIniciais.etapaWhatsApp ||
                tagWhatsApp !== valoresIniciais.tagWhatsApp;
            setMudancasWhatsApp(mudou);
        }
    }, [etapaWhatsApp, tagWhatsApp, valoresIniciais]);

    // Detectar mudanças em Agendar Visita
    useEffect(() => {
        if (valoresIniciais.agendarVisitaCrm !== undefined) {
            setMudancasAgendarVisita(agendarVisitaCrm !== valoresIniciais.agendarVisitaCrm);
        }
    }, [agendarVisitaCrm, valoresIniciais.agendarVisitaCrm]);

    // Buscar produtos do backend
    useEffect(() => {
        const fetchProdutos = async () => {
            try {
                setIsLoadingProdutos(true);

                const token = localStorage.getItem('jwtToken');
                if (!token) {
                    console.error("Token não encontrado no localStorage.");
                    return;
                }

                const decodedToken = jwtDecode(token);
                const idClienteAipim = decodedToken.id_cliente;

                const response = await axios.get(`${baseURL}/produto/sdr/produtos`, {
                    params: { idClienteAipim },
                    headers: { Authorization: `Bearer ${token}` }
                });

                // Filtrar apenas produtos ativos
                const produtosAtivos = response.data.filter(p => p.ativo === true);
                setProdutos(produtosAtivos);

                // Inicializar filasPorProduto com os valores vindos do backend
                const filasIniciais = {};
                produtosAtivos.forEach((produto, index) => {
                    const idChaveProduto =
                        produto.idEmpreendimentoCrm ??
                        produto.idProduto ??
                        index;

                    if (produto.idFilaDescarteCadencia) {
                        filasIniciais[idChaveProduto] = produto.idFilaDescarteCadencia;
                    }
                });
                setFilasPorProduto(filasIniciais);

                setValoresIniciais(prev => ({
                    ...prev,
                    filasPorProduto: filasIniciais
                }));
            } catch (error) {
                console.error("Erro ao buscar produtos:", error);
            } finally {
                setIsLoadingProdutos(false);
            }
        };

        if (baseURL) {
            fetchProdutos();
        }
    }, [baseURL]);

    // Função para extrair nome do usuário do token JWT no localStorage
    const getNomeUsuario = () => {
        try {
            const token = localStorage.getItem('jwtToken');
            if (token) {
                // Decodifica o JWT (payload está na segunda parte)
                const decodedToken = jwtDecode(token);
                const nomeUsuario = decodedToken.nome;

                return nomeUsuario || 'Usuário não identificado';
            }
            return 'Usuário não identificado';
        } catch (error) {
            console.error('Erro ao decodificar token JWT:', error);
            return 'Usuário não identificado';
        }
    };

    const handleSalvarParametros = async () => {
        if (readonly) {
            return;
        }

        setSalvandoParametro(true);

        try {
            const token = localStorage.getItem('jwtToken');
            if (!token) {
                console.error("Token não encontrado no localStorage.");
                return;
            }

            const decodedToken = jwtDecode(token);
            const idClienteAipim = decodedToken.id_cliente;
            const idUsuario = decodedToken?.id_usuario ?? decodedToken?.idUsuario ?? null;

            // Montar payload baseado na seção
            let payload = { idCrm: idCRM };
            let campoAlterado = "";
            let valorAnterior = "";
            let valorNovo = "";

            // Para cadência: controlar updates por produto
            let produtosAlterados = [];
            const getPayloadValue = (valorAtual, valorInicial) => {
                if (valorAtual === valorInicial) return "";
                if (valorAtual === "" || valorAtual == null) return null;
                return valorAtual;
            };

            const getFilaPayloadValue = (valorAtual, valorInicial) => {
                if (valorAtual === valorInicial) return "";
                if (valorAtual === "" || valorAtual == null) return null;
                return valorAtual;
            };


            switch (secaoAtual) {
                case "atendimento":
                    payload.idSituacaoCvAiLaura = getPayloadValue(
                        etapaAtendimento,
                        valoresIniciais.etapaAtendimento
                    );
                    campoAlterado = "Etapa de Atendimento";

                    // Buscar nome da etapa anterior e nova
                    const etapaAnt = workflows.find(e => e.idsituacao === valoresIniciais.etapaAtendimento);
                    const etapaNova = workflows.find(e => e.idsituacao === etapaAtendimento);

                    const atendimentoLabel = "Atendimento - Etapa";
                    valorAnterior = `${atendimentoLabel}: "${etapaAnt ? `${etapaAnt.nome} (ID: ${etapaAnt.idsituacao})` : valoresIniciais.etapaAtendimento || "Não definido"}"`;
                    valorNovo = `${atendimentoLabel}: "${etapaNova ? `${etapaNova.nome} (ID: ${etapaNova.idsituacao})` : etapaAtendimento || "Não definido"}"`;
                    break;

                case "qualificacao":
                    payload.idSituacaoCvQualificado = getPayloadValue(
                        etapaQualificado,
                        valoresIniciais.etapaQualificado
                    );
                    payload.idFilaCvQualifica = getFilaPayloadValue(
                        filaQualificado,
                        valoresIniciais.filaQualificado
                    );
                    payload.tagCvQualificado = getPayloadValue(
                        snakeCase(tagQualificado),
                        snakeCase(valoresIniciais.tagQualificado || "")
                    );
                    campoAlterado = "Qualificação";

                    const mudancas = [];
                    const qualificacaoLabel = "Qualificação";

                    // Etapa
                    if (etapaQualificado !== valoresIniciais.etapaQualificado) {
                        const etapaAntQual = workflows.find(e => e.idsituacao === valoresIniciais.etapaQualificado);
                        const etapaNovaQual = workflows.find(e => e.idsituacao === etapaQualificado);
                        mudancas.push({
                            campo: `${qualificacaoLabel} - Etapa`,
                            anterior: etapaAntQual ? `${etapaAntQual.nome} (ID: ${etapaAntQual.idsituacao})` : valoresIniciais.etapaQualificado || "Não definido",
                            novo: etapaNovaQual ? `${etapaNovaQual.nome} (ID: ${etapaNovaQual.idsituacao})` : etapaQualificado || "Não definido"
                        });
                    }

                    // Fila
                    if (filaQualificado !== valoresIniciais.filaQualificado) {
                        const filaAnt = filas.find(f => f.idfila_distribuicao_leads === valoresIniciais.filaQualificado);
                        const filaNova = filas.find(f => f.idfila_distribuicao_leads === filaQualificado);
                        mudancas.push({
                            campo: `${qualificacaoLabel} - Fila`,
                            anterior: filaAnt ? `${filaAnt.nome || 'Fila'} (ID: ${filaAnt.idfila_distribuicao_leads})` : valoresIniciais.filaQualificado || "Nenhuma fila",
                            novo: filaNova ? `${filaNova.nome || 'Fila'} (ID: ${filaNova.idfila_distribuicao_leads})` : filaQualificado || "Nenhuma fila"
                        });
                    }

                    // Tag
                    if (tagQualificado !== valoresIniciais.tagQualificado) {
                        mudancas.push({
                            campo: `${qualificacaoLabel} - Tag`,
                            anterior: valoresIniciais.tagQualificado || "Vazio",
                            novo: tagQualificado || "Vazio"
                        });
                    }

                    valorAnterior = mudancas.map(m => `${m.campo}: "${m.anterior}"`).join(" | ");
                    valorNovo = mudancas.map(m => `${m.campo}: "${m.novo}"`).join(" | ");
                    break;

                case "descarte":
                    payload.idSituacaoCvDescarte = getPayloadValue(
                        etapaDescartado,
                        valoresIniciais.etapaDescartado
                    );
                    payload.idFilaCvDescarte = getFilaPayloadValue(
                        filaDescartado,
                        valoresIniciais.filaDescartado
                    );
                    payload.tagCvDescarte = getPayloadValue(
                        snakeCase(tagDescartado),
                        snakeCase(valoresIniciais.tagDescartado || "")
                    );
                    campoAlterado = "Descarte";

                    const mudancasDesc = [];
                    const descarteLabel = "Descarte";

                    // Etapa
                    if (etapaDescartado !== valoresIniciais.etapaDescartado) {
                        const etapaAntDesc = workflows.find(e => e.idsituacao === valoresIniciais.etapaDescartado);
                        const etapaNovaDesc = workflows.find(e => e.idsituacao === etapaDescartado);
                        mudancasDesc.push({
                            campo: `${descarteLabel} - Etapa`,
                            anterior: etapaAntDesc ? `${etapaAntDesc.nome} (ID: ${etapaAntDesc.idsituacao})` : valoresIniciais.etapaDescartado || "Não definido",
                            novo: etapaNovaDesc ? `${etapaNovaDesc.nome} (ID: ${etapaNovaDesc.idsituacao})` : etapaDescartado || "Não definido"
                        });
                    }

                    // Fila
                    if (filaDescartado !== valoresIniciais.filaDescartado) {
                        const filaAntDesc = filas.find(f => f.idfila_distribuicao_leads === valoresIniciais.filaDescartado);
                        const filaNovaDesc = filas.find(f => f.idfila_distribuicao_leads === filaDescartado);
                        mudancasDesc.push({
                            campo: `${descarteLabel} - Fila`,
                            anterior: filaAntDesc ? `${filaAntDesc.nome || 'Fila'} (ID: ${filaAntDesc.idfila_distribuicao_leads})` : valoresIniciais.filaDescartado || "Nenhuma fila",
                            novo: filaNovaDesc ? `${filaNovaDesc.nome || 'Fila'} (ID: ${filaNovaDesc.idfila_distribuicao_leads})` : filaDescartado || "Nenhuma fila"
                        });
                    }

                    // Tag
                    if (tagDescartado !== valoresIniciais.tagDescartado) {
                        mudancasDesc.push({
                            campo: `${descarteLabel} - Tag`,
                            anterior: valoresIniciais.tagDescartado || "Vazio",
                            novo: tagDescartado || "Vazio"
                        });
                    }

                    valorAnterior = mudancasDesc.map(m => `${m.campo}: "${m.anterior}"`).join(" | ");
                    valorNovo = mudancasDesc.map(m => `${m.campo}: "${m.novo}"`).join(" | ");
                    break;

                case "cadencia":
                    // Body para o endpoint geral de configurações
                    payload.ncadencias = getPayloadValue(
                        numeroTentativas,
                        valoresIniciais.numeroTentativas
                    ); // se o backend usar "ncadencias"
                    // se ele ainda estiver esperando "ncadencias", mantenha como estava:
                    // payload.ncadencias = numeroTentativas;

                    payload.idSituacaoCvDescarteCadencia = getPayloadValue(
                        etapaCadenciaDescartado,
                        valoresIniciais.etapaCadenciaDescartado
                    );
                    payload.idFilaCvDescarteCadencia = getFilaPayloadValue(
                        filaCadenciaGeral,
                        valoresIniciais.filaCadenciaGeral
                    );
                    payload.tagCvDescarteCadencia = getPayloadValue(
                        snakeCase(tagCadencia),
                        snakeCase(valoresIniciais.tagCadencia || "")
                    );
                    campoAlterado = "Tentativas de Contato/Cadência";

                    const mudancasCad = [];
                    const cadenciaLabel = "Cadência";

                    // Número de tentativas
                    if (numeroTentativas !== valoresIniciais.numeroTentativas) {
                        mudancasCad.push({
                            campo: `${cadenciaLabel} - Número de Tentativas`,
                            anterior: valoresIniciais.numeroTentativas || "Não definido",
                            novo: numeroTentativas || "Não definido"
                        });
                    }

                    // Etapa
                    if (etapaCadenciaDescartado !== valoresIniciais.etapaCadenciaDescartado) {
                        const etapaAntCad = workflows.find(e => e.idsituacao === valoresIniciais.etapaCadenciaDescartado);
                        const etapaNovaCad = workflows.find(e => e.idsituacao === etapaCadenciaDescartado);
                        mudancasCad.push({
                            campo: `${cadenciaLabel} - Etapa`,
                            anterior: etapaAntCad ? `${etapaAntCad.nome} (ID: ${etapaAntCad.idsituacao})` : valoresIniciais.etapaCadenciaDescartado || "Não definido",
                            novo: etapaNovaCad ? `${etapaNovaCad.nome} (ID: ${etapaNovaCad.idsituacao})` : etapaCadenciaDescartado || "Não definido"
                        });
                    }

                    // Fila geral
                    if (filaCadenciaGeral !== valoresIniciais.filaCadenciaGeral) {
                        const filaAntCad = filas.find(f => f.idfila_distribuicao_leads === valoresIniciais.filaCadenciaGeral);
                        const filaNovaCad = filas.find(f => f.idfila_distribuicao_leads === filaCadenciaGeral);
                        mudancasCad.push({
                            campo: `${cadenciaLabel} - Fila`,
                            anterior: filaAntCad ? `${filaAntCad.nome || 'Fila'} (ID: ${filaAntCad.idfila_distribuicao_leads})` : valoresIniciais.filaCadenciaGeral || "Nenhuma fila",
                            novo: filaNovaCad ? `${filaNovaCad.nome || 'Fila'} (ID: ${filaNovaCad.idfila_distribuicao_leads})` : filaCadenciaGeral || "Nenhuma fila"
                        });
                    }

                    // Tag
                    if (tagCadencia !== valoresIniciais.tagCadencia) {
                        mudancasCad.push({
                            campo: `${cadenciaLabel} - Tag`,
                            anterior: valoresIniciais.tagCadencia || "Vazio",
                            novo: tagCadencia || "Vazio"
                        });
                    }

                    // *** Empreendimentos (produtos) ***
                    const mudancasProd = [];

                    produtosAlterados = (produtos || [])
                        .map((produto, index) => {
                            // mesma lógica de chave que você usa na Fila por Produto
                            const idChaveProduto =
                                produto.idEmpreendimentoCrm ??
                                produto.idProduto ??
                                index;

                            const filaAtual = (filasPorProduto || {})[idChaveProduto];
                            const filaInicial = (valoresIniciais.filasPorProduto || {})[idChaveProduto];

                            // Se não mudou, não entra em PUT nem na justificativa
                            if (filaAtual === filaInicial) return null;

                            // Descobre o nome da fila anterior e atual
                            const filaAntObj = filas.find(f => f.idfila_distribuicao_leads === filaInicial);
                            const filaNovaObj = filas.find(f => f.idfila_distribuicao_leads === filaAtual);

                            // Aqui vai pro texto da justificativa, no formato simples:
                            // Empreendimento X: "Nome da Fila (ID: Id)"
                            mudancasProd.push({
                                campo: `${cadenciaLabel} - ${produto.nome}`,
                                anterior: filaAntObj
                                    ? `${filaAntObj.nome || 'Nenhuma fila'} (ID: ${filaAntObj.idfila_distribuicao_leads})`
                                    : "Nenhuma fila",
                                novo: filaNovaObj
                                    ? `${filaNovaObj.nome || 'Nenhuma fila'} (ID: ${filaNovaObj.idfila_distribuicao_leads})`
                                    : "Nenhuma fila"
                            });

                            // Payload para o endpoint de fila-descarte-cadencia
                            return {
                                idEmpreendimento: produto.id,
                                idFilaDescarteCadencia:
                                    filaAtual === "" || filaAtual == null ? null : filaAtual
                            };
                        })
                        .filter(Boolean);

                    // Junta mudanças gerais + por produto
                    const todasMudancas = [...mudancasCad, ...mudancasProd];

                    valorAnterior = todasMudancas.map(m => `${m.campo}: "${m.anterior}"`).join(" | ");
                    valorNovo = todasMudancas.map(m => `${m.campo}: "${m.novo}"`).join(" | ");
                    break;

                case "whatsapp":
                    payload.idSituacaoCvNaoWhatsapp = getPayloadValue(
                        etapaWhatsApp,
                        valoresIniciais.etapaWhatsApp
                    );
                    payload.tagCvNaoWhatsapp = getPayloadValue(
                        snakeCase(tagWhatsApp),
                        snakeCase(valoresIniciais.tagWhatsApp || "")
                    );
                    campoAlterado = "Números que não são WhatsApp";

                    const mudancasWhats = [];
                    const whatsappLabel = "Não é WhatsApp";

                    // Etapa
                    if (etapaWhatsApp !== valoresIniciais.etapaWhatsApp) {
                        const etapaAntWhats = workflows.find(e => e.idsituacao === valoresIniciais.etapaWhatsApp);
                        const etapaNovaWhats = workflows.find(e => e.idsituacao === etapaWhatsApp);
                        mudancasWhats.push({
                            campo: `${whatsappLabel} - Etapa`,
                            anterior: etapaAntWhats ? `${etapaAntWhats.nome} (ID: ${etapaAntWhats.idsituacao})` : valoresIniciais.etapaWhatsApp || "Não definido",
                            novo: etapaNovaWhats ? `${etapaNovaWhats.nome} (ID: ${etapaNovaWhats.idsituacao})` : etapaWhatsApp || "Não definido"
                        });
                    }

                    // Tag
                    if (tagWhatsApp !== valoresIniciais.tagWhatsApp) {
                        mudancasWhats.push({
                            campo: `${whatsappLabel} - Tag`,
                            anterior: valoresIniciais.tagWhatsApp || "Vazio",
                            novo: tagWhatsApp || "Vazio"
                        });
                    }

                    valorAnterior = mudancasWhats.map(m => `${m.campo}: "${m.anterior}"`).join(" | ");
                    valorNovo = mudancasWhats.map(m => `${m.campo}: "${m.novo}"`).join(" | ");
                    break;

                case "agendarVisita":
                    payload.agendarVisitaCrm = getPayloadValue(
                        agendarVisitaCrm,
                        valoresIniciais.agendarVisitaCrm
                    );
                    campoAlterado = "Agendar Visita no CV";

                    const agendarLabel = "Agendar Visita - Status";
                    valorAnterior = `${agendarLabel}: "${valoresIniciais.agendarVisitaCrm ? "Ativado" : "Desativado"}"`;
                    valorNovo = `${agendarLabel}: "${agendarVisitaCrm ? "Ativado" : "Desativado"}"`;
                    break;

                default:
                    console.error("Seção não reconhecida:", secaoAtual);
                    return;
            }

            console.log(campoAlterado)

            const payloadJustificativa = {
                idClienteAipim,
                idUsuario,
                idProduto: 2,
                campo: "Parâmetros do Agente",
                valorNovo: valorNovo,
                valorAnterior: valorAnterior,
                justificativa: `${justificativaSalvar}`
            };

            // 1) Salvar no backend - PUT geral de configurações
            await axios.put(
                `${baseURL}/produto/sdr/parametros`,
                payload,
                {
                    params: { idClienteAipim },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            // 2) Se houver produtos com fila alterada, atualiza cada um no endpoint específico
            if (produtosAlterados.length > 0) {
                for (const produto of produtosAlterados) {
                    await axios.put(
                        `${baseURL}/produto/sdr/produto/fila-descarte-cadencia`,
                        produto, // body: { idEmpreendimento, idFilaDescarteCadencia }
                        {
                            params: { idClienteAipim },
                            headers: { Authorization: `Bearer ${token}` }
                        }
                    );
                }
            }

            // 3) ✅ Só aqui, depois de TODOS os PUTs terem dado certo, envia a justificativa
            await axios.post(
                `${baseURL}/produto/Justificativa`,
                payloadJustificativa,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Atualizar valores iniciais baseado na seção
            const novosValoresIniciais = { ...valoresIniciais };

            switch (secaoAtual) {
                case "atendimento":
                    novosValoresIniciais.etapaAtendimento = etapaAtendimento;
                    break;
                case "qualificacao":
                    novosValoresIniciais.etapaQualificado = etapaQualificado;
                    novosValoresIniciais.filaQualificado = filaQualificado;
                    novosValoresIniciais.tagQualificado = tagQualificado;
                    break;
                case "descarte":
                    novosValoresIniciais.etapaDescartado = etapaDescartado;
                    novosValoresIniciais.filaDescartado = filaDescartado;
                    novosValoresIniciais.tagDescartado = tagDescartado;
                    break;
                case "cadencia":
                    novosValoresIniciais.numeroTentativas = numeroTentativas;
                    novosValoresIniciais.etapaCadenciaDescartado = etapaCadenciaDescartado;
                    novosValoresIniciais.filaCadenciaGeral = filaCadenciaGeral;
                    novosValoresIniciais.tagCadencia = tagCadencia;
                    novosValoresIniciais.filasPorProduto = { ...filasPorProduto };
                    break;
                case "whatsapp":
                    novosValoresIniciais.etapaWhatsApp = etapaWhatsApp;
                    novosValoresIniciais.tagWhatsApp = tagWhatsApp;
                    break;
                case "agendarVisita":
                    novosValoresIniciais.agendarVisitaCrm = agendarVisitaCrm;
                    break;

                default:
                    break;
            }

            setValoresIniciais(novosValoresIniciais);

            setDialogSalvarOpen(false);
            setJustificativaSalvar("");
        } catch (error) {
            console.error("Erro ao salvar parâmetros:", error);
            // FECHAR O DIÁLOGO MESMO EM CASO DE ERRO
            setDialogSalvarOpen(false);
            setJustificativaSalvar("");
        } finally {
            setSalvandoParametro(false);
        }
    };

    // Helpers para montar opções a partir de workflows e filas
    const renderOpcoesEtapas = () => {
        if (!workflows || workflows.length === 0) {
            return <MenuItem value="" disabled>Sem Etapa Cadastrada</MenuItem>;
        }
        return workflows.map((etapa, index) => (
            <MenuItem key={`${etapa.idsituacao ?? 'etapa'}-${index}`} value={etapa.idsituacao}>
                {etapa.nome} (ID: {etapa.idsituacao})
            </MenuItem>
        ));
    };

    const renderOpcoesFilas = () => {
        if (!filas || filas.length === 0) {
            return <MenuItem value="" disabled>Sem Fila Cadastrada</MenuItem>;
        }
        return filas.map((fila, index) => {
            const valor = fila.idfila_distribuicao_leads;
            const label = fila.nome || `Fila ${fila.idfila_distribuicao_leads}`;

            return (
                <MenuItem key={`${valor ?? 'fila'}-${index}`} value={valor}>
                    {label} (ID: {valor})
                </MenuItem>
            );
        });
    };

    const formTableSx = {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '320px minmax(0, 1fr)' },
        columnGap: 2,
        rowGap: 2,
        alignItems: 'center',
        mb: 2,
    };

    const formLabelSx = {
        fontWeight: 500,
        color: 'text.primary',
    };

    if (isLoadingConfiguracoes || isLoadingProdutos) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    width: '100%',
                    color: 'text.primary',
                }}
            >
                <Sidebar
                    aria-label="Menu de navegação lateral"
                    sx={{
                        width: { xs: '100%', md: 280 },
                        flexShrink: 0,
                        order: { xs: 2, md: 1 },
                    }}
                />

                <Box
                    sx={{
                        flexGrow: 1,
                        order: { xs: 1, md: 2 },
                        width: { xs: '100%', md: 'auto' },
                    }}
                >
                    {/* Container Principal */}
                    <Paper
                        elevation={0}
                        sx={{
                            bgcolor: 'background.paper',
                            borderRadius: { xs: 2, md: 3 },
                            p: { xs: 2, sm: 3, md: 4 },
                            boxShadow: {
                                xs: '0 2px 10px rgba(0,0,0,0.08)',
                                md: '0 4px 20px rgba(0,0,0,0.08)'
                            },
                            border: '1px solid',
                            borderColor: 'divider',
                        }}
                    >
                        {/* Atendimento */}
                        {idCRM === 1 && (
                            <Box sx={{ mb: -1 }}>
                                <Button
                                    fullWidth
                                    onClick={() => setExpandidoAtendimento(!expandidoAtendimento)}
                                    endIcon={
                                        <ExpandMoreIcon
                                            sx={{
                                                transform: expandidoAtendimento ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease'
                                            }}
                                        />
                                    }
                                    sx={{
                                        justifyContent: 'space-between',
                                        textAlign: 'left',
                                        py: 2,
                                        px: 3,
                                        mb: 1,
                                        backgroundColor: 'action.hover',
                                        color: 'text.primary',
                                        textTransform: 'none',
                                        '&:hover': {
                                            backgroundColor: 'action.selected'
                                        }
                                    }}
                                >
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        maxWidth: '300px' // Ajuste a largura aqui
                                    }}>
                                        <Typography variant="h6" sx={{ color: '#667eea', fontWeight: 500, fontSize: 15 }}>
                                            Atendimento
                                        </Typography>
                                        <Tooltip
                                            title="Nesta seção, você pode configurar qual deve ser a etapa no CRM enquanto o lead estiver em atendimento."
                                            arrow
                                            slotProps={{
                                                tooltip: {
                                                    sx: {
                                                        fontSize: 16, // tamanho da fonte do tooltip
                                                        width: 300,
                                                    },
                                                },
                                            }}
                                        >
                                            <HelpOutlineOutlinedIcon
                                                sx={{
                                                    fontSize: 20,
                                                    color: '#667eea',
                                                    cursor: 'help',
                                                }}
                                            />
                                        </Tooltip>
                                    </Box>
                                </Button>

                                <Collapse in={expandidoAtendimento}>
                                    <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
                                        <Box sx={formTableSx}>
                                            <Typography sx={formLabelSx}>
                                                Etapa do Lead durante o atendimento do Agente:
                                            </Typography>
                                            <TextField
                                                select
                                                value={etapaAtendimento}
                                                onChange={(e) => !readonly && setEtapaAtendimento(e.target.value)}
                                                sx={{
                                                    flexGrow: 1,
                                                    maxWidth: '200px',
                                                    '& .MuiInputBase-root': {
                                                        height: '36px',
                                                        fontSize: '0.875rem'
                                                    },
                                                    '& .MuiSelect-select': {
                                                        paddingTop: '8px',
                                                        paddingBottom: '8px'
                                                    }
                                                }}
                                            >
                                                {renderOpcoesEtapas()}
                                            </TextField>
                                        </Box>

                                        {(mudancasAtendimento && !readonly) && (
                                            <Button
                                                onClick={() => {
                                                    setSecaoAtual("atendimento");
                                                    setJustificativaSalvar("");
                                                    openDialogSalvar();
                                                }}
                                                sx={{
                                                    background: '#339e65ff',
                                                    mb: 1,
                                                    color: '#fff',
                                                    '&:hover': {
                                                        background: '#2d8757'
                                                    }
                                                }}
                                            >
                                                Salvar
                                            </Button>
                                        )}
                                    </Box>
                                </Collapse>
                            </Box>
                        )}

                        {idCRM === 1 && (
                            <>
                                <Divider sx={{ my: 1.5 }} />

                                {/* Qualificação */}
                                <Box sx={{ mb: -1 }}>
                                    <Button
                                        fullWidth
                                        onClick={() => setExpandidoQualificacao(!expandidoQualificacao)}
                                        endIcon={
                                            <ExpandMoreIcon
                                                sx={{
                                                    transform: expandidoQualificacao ? 'rotate(180deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease'
                                                }}
                                            />
                                        }
                                        sx={{
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            py: 2,
                                            px: 3,
                                            mb: 1,
                                            backgroundColor: 'action.hover',
                                            color: 'text.primary',
                                            textTransform: 'none',
                                            '&:hover': {
                                                backgroundColor: 'action.selected'
                                            }
                                        }}
                                    >
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            maxWidth: '300px' // Ajuste a largura aqui
                                        }}>
                                            <Typography variant="h6" sx={{ color: '#667eea', fontWeight: 500, fontSize: 15 }}>
                                                Qualificação
                                            </Typography>
                                            <Tooltip
                                                title="Nesta seção, você pode configurar o que deve ser feito quando o lead for qualificado, definindo para qual etapa ele deve ser movido e se uma fila ou tag deve ser aplicada."
                                                arrow
                                                slotProps={{
                                                    tooltip: {
                                                        sx: {
                                                            fontSize: 16, // tamanho da fonte do tooltip
                                                            width: 300,
                                                        },
                                                    },
                                                }}
                                            >
                                                <HelpOutlineOutlinedIcon
                                                    sx={{
                                                        fontSize: 20,
                                                        color: '#667eea',
                                                        cursor: 'help',
                                                    }}
                                                />
                                            </Tooltip>
                                        </Box>
                                    </Button>

                                    <Collapse in={expandidoQualificacao}>
                                        <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
                                            <Box sx={formTableSx}>
                                                <Typography sx={formLabelSx}>
                                                    Etapa para o Lead Qualificado:
                                                </Typography>
                                                <TextField
                                                    select
                                                    value={etapaQualificado}
                                                    onChange={(e) => !readonly && setEtapaQualificado(e.target.value)}
                                                    sx={{
                                                        flexGrow: 1,
                                                        maxWidth: '200px',
                                                        '& .MuiInputBase-root': {
                                                            height: '36px',
                                                            fontSize: '0.875rem'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            paddingTop: '8px',
                                                            paddingBottom: '8px'
                                                        }
                                                    }}
                                                >
                                                    {renderOpcoesEtapas()}
                                                </TextField>
                                                <Typography sx={formLabelSx}>
                                                    Fila para o Lead Qualificado:
                                                </Typography>
                                                <TextField
                                                    select
                                                    value={filaQualificado || ''}
                                                    onChange={(e) => !readonly && setFilaQualificado(e.target.value)}
                                                    sx={{
                                                        flexGrow: 1,
                                                        maxWidth: '200px',
                                                        '& .MuiInputBase-root': {
                                                            height: '36px',
                                                            fontSize: '0.875rem'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            paddingTop: '8px',
                                                            paddingBottom: '8px'
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">Nenhuma fila selecionada</MenuItem>
                                                    {renderOpcoesFilas()}
                                                </TextField>
                                                <Typography sx={formLabelSx}>
                                                    Tag para o Lead Qualificado:
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, maxWidth: '400px', gap: 2, alignItems: 'center' }}>
                                                    <Tooltip
                                                        title="Use underscore (_) no lugar de espaços. Caracteres especiais não são permitidos."
                                                        open={erroTagQualificado}
                                                        arrow
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    fontSize: 14,
                                                                    bgcolor: '#d32f2f',
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <TextField
                                                            disabled={readonly}
                                                            value={tagQualificado}
                                                            onChange={(e) => {
                                                                const valor = e.target.value;
                                                                const temErro = validarTag(valor);
                                                                setErroTagQualificado(temErro);

                                                                if (!temErro && valor.length <= 25) {
                                                                    setTagQualificado(valor);
                                                                }
                                                            }}
                                                            onBlur={() => setErroTagQualificado(false)}
                                                            placeholder="Digite a tag"
                                                            inputProps={{ maxLength: 25 }}
                                                            error={erroTagQualificado}
                                                            sx={{
                                                                '& .MuiInputBase-root': {
                                                                    height: '36px',
                                                                    fontSize: '0.875rem'
                                                                },
                                                                '& .MuiSelect-select': {
                                                                    paddingTop: '8px',
                                                                    paddingBottom: '8px'
                                                                },
                                                                '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                    borderColor: '#d32f2f',
                                                                    borderWidth: '2px'
                                                                }
                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            mt: 0.5,
                                                            color: tagQualificado.length >= 25 ? '#d32f2f' : '#666',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        {tagQualificado.length}/25 caracteres
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {(mudancasQualificacao && !readonly) && (
                                                <Button
                                                    onClick={() => {
                                                        setSecaoAtual("qualificacao");
                                                        setJustificativaSalvar("");
                                                        openDialogSalvar();
                                                    }}
                                                    sx={{
                                                        background: '#339e65ff',
                                                        mb: 1,
                                                        color: '#fff',
                                                        '&:hover': {
                                                            background: '#2d8757'
                                                        }
                                                    }}
                                                >
                                                    Salvar
                                                </Button>
                                            )}
                                        </Box>
                                    </Collapse>
                                </Box>
                            </>
                        )}

                        {idCRM === 1 && (
                            <>
                                <Divider sx={{ my: 1.5 }} />

                                {/* Descarte */}
                                <Box sx={{ mb: -1 }}>
                                    <Button
                                        fullWidth
                                        onClick={() => setExpandidoDescarte(!expandidoDescarte)}
                                        endIcon={
                                            <ExpandMoreIcon
                                                sx={{
                                                    transform: expandidoDescarte ? 'rotate(180deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease'
                                                }}
                                            />
                                        }
                                        sx={{
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            py: 2,
                                            px: 3,
                                            mb: 1,
                                            backgroundColor: 'action.hover',
                                            color: 'text.primary',
                                            textTransform: 'none',
                                            '&:hover': {
                                                backgroundColor: 'action.selected'
                                            }
                                        }}
                                    >
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            maxWidth: '300px' // Ajuste a largura aqui
                                        }}>
                                            <Typography variant="h6" sx={{ color: '#667eea', fontWeight: 500, fontSize: 15 }}>
                                                Descarte
                                            </Typography>
                                            <Tooltip
                                                title="Nesta seção, você pode configurar o que deve ser feito quando o Lead for descartado, definindo para qual etapa ele deve ser enviado e se alguma fila ou tag deve ser aplicada."
                                                arrow
                                                slotProps={{
                                                    tooltip: {
                                                        sx: {
                                                            fontSize: 16, // tamanho da fonte do tooltip
                                                            width: 300,
                                                        },
                                                    },
                                                }}
                                            >
                                                <HelpOutlineOutlinedIcon
                                                    sx={{
                                                        fontSize: 20,
                                                        color: '#667eea',
                                                        cursor: 'help',
                                                    }}
                                                />
                                            </Tooltip>
                                        </Box>
                                    </Button>

                                    <Collapse in={expandidoDescarte}>
                                        <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
                                            <Box sx={formTableSx}>
                                                <Typography sx={formLabelSx}>
                                                    Etapa Lead Descartado:
                                                </Typography>
                                                <TextField
                                                    select
                                                    value={etapaDescartado}
                                                    onChange={(e) => !readonly && setEtapaDescartado(e.target.value)}
                                                    sx={{
                                                        flexGrow: 1,
                                                        maxWidth: '200px',
                                                        '& .MuiInputBase-root': {
                                                            height: '36px',
                                                            fontSize: '0.875rem'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            paddingTop: '8px',
                                                            paddingBottom: '8px'
                                                        }
                                                    }}
                                                >
                                                    {renderOpcoesEtapas()}
                                                </TextField>
                                                <Typography sx={formLabelSx}>
                                                    Fila Lead Descartado:
                                                </Typography>
                                                <TextField
                                                    select
                                                    value={filaDescartado || ''}
                                                    onChange={(e) => !readonly && setFilaDescartado(e.target.value)}
                                                    sx={{
                                                        flexGrow: 1,
                                                        maxWidth: '200px',
                                                        '& .MuiInputBase-root': {
                                                            height: '36px',
                                                            fontSize: '0.875rem'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            paddingTop: '8px',
                                                            paddingBottom: '8px'
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">Nenhuma fila selecionada</MenuItem>
                                                    {renderOpcoesFilas()}
                                                </TextField>
                                                <Typography sx={formLabelSx}>
                                                    Tag para Lead Descartado:
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, maxWidth: '400px', gap: 2, alignItems: 'center' }}>
                                                    <Tooltip
                                                        title="Use underscore (_) no lugar de espaços. Caracteres especiais não são permitidos."
                                                        open={erroTagDescartado}
                                                        arrow
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    fontSize: 14,
                                                                    bgcolor: '#d32f2f',
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <TextField
                                                            disabled={readonly}
                                                            value={tagDescartado}
                                                            onChange={(e) => {
                                                                const valor = e.target.value;
                                                                const temErro = validarTag(valor);
                                                                setErroTagDescartado(temErro);

                                                                if (!temErro && valor.length <= 25) {
                                                                    setTagDescartado(valor);
                                                                }
                                                            }}
                                                            onBlur={() => setErroTagDescartado(false)}
                                                            placeholder="Digite a tag"
                                                            inputProps={{ maxLength: 25 }}
                                                            error={erroTagDescartado}
                                                            sx={{
                                                                '& .MuiInputBase-root': {
                                                                    height: '36px',
                                                                    fontSize: '0.875rem'
                                                                },
                                                                '& .MuiSelect-select': {
                                                                    paddingTop: '8px',
                                                                    paddingBottom: '8px'
                                                                },
                                                                '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                    borderColor: '#d32f2f',
                                                                    borderWidth: '2px'
                                                                }
                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            mt: 0.5,
                                                            color: tagDescartado.length >= 25 ? '#d32f2f' : '#666',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        {tagDescartado.length}/25 caracteres
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {(mudancasDescarte && !readonly) && (
                                                <Button
                                                    onClick={() => {
                                                        setSecaoAtual("descarte");
                                                        setJustificativaSalvar("");
                                                        openDialogSalvar();
                                                    }}
                                                    sx={{
                                                        background: '#339e65ff',
                                                        mb: 1,
                                                        color: '#fff',
                                                        '&:hover': {
                                                            background: '#2d8757'
                                                        }
                                                    }}
                                                >
                                                    Salvar
                                                </Button>
                                            )}
                                        </Box>
                                    </Collapse>
                                </Box>
                            </>
                        )}

                        <Divider sx={{ my: 1.5 }} />

                        {/* Tentativas de Contato */}
                        <Box sx={{ mb: -1 }}>
                            <Button
                                fullWidth
                                onClick={() => setExpandidoCadencia(!expandidoCadencia)}
                                endIcon={
                                    <ExpandMoreIcon
                                        sx={{
                                            transform: expandidoCadencia ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease'
                                        }}
                                    />
                                }
                                sx={{
                                    justifyContent: 'space-between',
                                    textAlign: 'left',
                                    py: 2,
                                    px: 3,
                                    mb: 1,
                                    backgroundColor: 'action.hover',
                                    color: 'text.primary',
                                    textTransform: 'none',
                                    '&:hover': {
                                        backgroundColor: 'action.selected'
                                    }
                                }}
                            >
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    maxWidth: '300px' // Ajuste a largura aqui
                                }}>
                                    <Typography variant="h6" sx={{ color: '#667eea', fontWeight: 500, fontSize: 15 }}>
                                        Tentativas de Contato/Cadência
                                    </Typography>
                                    <Tooltip
                                        title="Defina quantas mensagens devem ser enviadas, para qual etapa o lead deve ser movido e se uma fila ou tag deve ser aplicada."
                                        arrow
                                        slotProps={{
                                            tooltip: {
                                                sx: {
                                                    fontSize: 16, // tamanho da fonte do tooltip
                                                    width: 300,
                                                },
                                            },
                                        }}
                                    >
                                        <HelpOutlineOutlinedIcon
                                            sx={{
                                                fontSize: 20,
                                                color: '#667eea',
                                                cursor: 'help',
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                            </Button>

                            <Collapse in={expandidoCadencia}>
                                <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
                                    <Box sx={formTableSx}>
                                        <Typography sx={formLabelSx}>
                                            Número de Tentativas:
                                        </Typography>
                                        <TextField
                                            select
                                            value={numeroTentativas}
                                            onChange={(e) => !readonly && setNumeroTentativas(e.target.value)}
                                            sx={{
                                                flexGrow: 1,
                                                maxWidth: '200px',
                                                '& .MuiInputBase-root': {
                                                    height: '36px',
                                                    fontSize: '0.875rem'
                                                },
                                                '& .MuiSelect-select': {
                                                    paddingTop: '8px',
                                                    paddingBottom: '8px'
                                                }
                                            }}
                                        >
                                            {cadenciaOptions.map((option, index) => (
                                                <MenuItem key={`${option}-${index}`} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Box>

                                    {idCRM === 1 && (
                                        <>
                                            <Box sx={formTableSx}>
                                                <Typography sx={formLabelSx}>
                                                    Etapa após Tentativas Esgotadas:
                                                </Typography>
                                                <TextField
                                                    select
                                                    value={etapaCadenciaDescartado}
                                                    onChange={(e) => !readonly && setEtapaCadenciaDescartado(e.target.value)}
                                                    sx={{
                                                        flexGrow: 1,
                                                        maxWidth: '200px',
                                                        '& .MuiInputBase-root': {
                                                            height: '36px',
                                                            fontSize: '0.875rem'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            paddingTop: '8px',
                                                            paddingBottom: '8px'
                                                        }
                                                    }}
                                                >
                                                    {renderOpcoesEtapas()}
                                                </TextField>
                                            </Box>
                                            <Box sx={formTableSx}>
                                                <Typography sx={formLabelSx}>
                                                    Fila após Tentativas Esgotadas:
                                                </Typography>
                                                <TextField
                                                    select
                                                    value={filaCadenciaGeral || ''}
                                                    onChange={(e) => !readonly && setFilaCadenciaGeral(e.target.value)}
                                                    sx={{
                                                        flexGrow: 1,
                                                        maxWidth: '200px',
                                                        '& .MuiInputBase-root': {
                                                            height: '36px',
                                                            fontSize: '0.875rem'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            paddingTop: '8px',
                                                            paddingBottom: '8px'
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="">Nenhuma fila selecionada</MenuItem>
                                                    {renderOpcoesFilas()}
                                                </TextField>
                                            </Box>
                                            <Box sx={formTableSx}>
                                                <Typography sx={formLabelSx}>
                                                    Tag após Tentativas Esgotadas:
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, maxWidth: '400px', gap: 2, alignItems: 'center' }}>
                                                    <Tooltip
                                                        title="Use underscore (_) no lugar de espaços. Caracteres especiais não são permitidos."
                                                        open={erroTagCadencia}
                                                        arrow
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    fontSize: 14,
                                                                    bgcolor: '#d32f2f',
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <TextField
                                                            disabled={readonly}
                                                            value={tagCadencia}
                                                            onChange={(e) => {
                                                                const valor = e.target.value;
                                                                const temErro = validarTag(valor);
                                                                setErroTagCadencia(temErro);

                                                                if (!temErro && valor.length <= 25) {
                                                                    setTagCadencia(valor);
                                                                }
                                                            }}
                                                            onBlur={() => setErroTagCadencia(false)}
                                                            placeholder="Digite a tag"
                                                            inputProps={{ maxLength: 25 }}
                                                            error={erroTagCadencia}
                                                            sx={{
                                                                '& .MuiInputBase-root': {
                                                                    height: '36px',
                                                                    fontSize: '0.875rem'
                                                                },
                                                                '& .MuiSelect-select': {
                                                                    paddingTop: '8px',
                                                                    paddingBottom: '8px'
                                                                },
                                                                '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                    borderColor: '#d32f2f',
                                                                    borderWidth: '2px'
                                                                }
                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            mt: 0.5,
                                                            color: tagCadencia.length >= 25 ? '#d32f2f' : '#666',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        {tagCadencia.length}/25 caracteres
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Fila Por Produto */}
                                            {produtos.length > 0 && (
                                                <Box sx={{ mt: 2 }}>
                                                    <Typography sx={{ fontWeight: 600, mb: 2, color: '#667eea' }}>
                                                        Fila por Produto:
                                                    </Typography>
                                                    <Box sx={{ ...formTableSx, mb: 0 }}>
                                                        {produtos.map((produto, index) => {
                                                            const idChaveProduto =
                                                                produto.idEmpreendimentoCrm ??
                                                                produto.idProduto ??
                                                                index;
                                                            const produtoKey = `${idChaveProduto}-${index}`;

                                                            return (
                                                                <React.Fragment key={produtoKey}>
                                                                    <Typography sx={formLabelSx}>
                                                                        {produto.nome}:
                                                                    </Typography>
                                                                    <TextField
                                                                        select
                                                                        value={filasPorProduto[idChaveProduto] || ''}
                                                                        onChange={(e) => {
                                                                            if (readonly) return;
                                                                            setFilasPorProduto(prev => ({
                                                                                ...prev,
                                                                                [idChaveProduto]: e.target.value
                                                                            }));
                                                                        }}
                                                                        sx={{
                                                                            flexGrow: 1,
                                                                            maxWidth: '200px',
                                                                            '& .MuiInputBase-root': {
                                                                                height: '36px',
                                                                                fontSize: '0.875rem'
                                                                            },
                                                                            '& .MuiSelect-select': {
                                                                                paddingTop: '8px',
                                                                                paddingBottom: '8px'
                                                                            }
                                                                        }}
                                                                    >
                                                                        <MenuItem value="">Nenhuma fila selecionada</MenuItem>
                                                                        {renderOpcoesFilas()}
                                                                    </TextField>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </Box>
                                                </Box>
                                            )}
                                        </>
                                    )}

                                    {(mudancasCadencia && !readonly) && (
                                        <Button
                                            onClick={() => {
                                                setSecaoAtual("cadencia");
                                                setJustificativaSalvar("");
                                                openDialogSalvar();
                                            }}
                                            sx={{
                                                background: '#339e65ff',
                                                mb: 1,
                                                color: '#fff',
                                                '&:hover': {
                                                    background: '#2d8757'
                                                }
                                            }}
                                        >
                                            Salvar
                                        </Button>
                                    )}
                                </Box>
                            </Collapse>
                        </Box>

                        {idCRM === 1 && (

                            <>
                                <Divider sx={{ my: 1.5 }} />

                                <Box sx={{ mb: -1 }}>
                                    <Button
                                        fullWidth
                                        onClick={() => setExpandidoWhatsApp(!expandidoWhatsApp)}
                                        endIcon={
                                            <ExpandMoreIcon
                                                sx={{
                                                    transform: expandidoWhatsApp ? 'rotate(180deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease'
                                                }}
                                            />
                                        }
                                        sx={{
                                            justifyContent: 'space-between',
                                            textAlign: 'left',
                                            py: 2,
                                            px: 3,
                                            mb: 1,
                                            backgroundColor: 'action.hover',
                                            color: 'text.primary',
                                            textTransform: 'none',
                                            '&:hover': {
                                                backgroundColor: 'action.selected'
                                            }
                                        }}
                                    >
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            maxWidth: '300px' // Ajuste a largura aqui
                                        }}>
                                            <Typography variant="h6" sx={{
                                                color: '#667eea',
                                                fontWeight: 500,
                                                fontSize: 15 // Ajuste o tamanho da fonte aqui
                                            }}>
                                                Números que não são WhatsApp
                                            </Typography>
                                            <Tooltip
                                                title="Nesta seção, você pode configurar o que deve ser feito quando o número do lead for inválido ou não for WhatsApp, definindo para qual etapa ele deve ser enviado e se alguma tag deve ser aplicada."
                                                arrow
                                                slotProps={{
                                                    tooltip: {
                                                        sx: {
                                                            fontSize: 16, // tamanho da fonte do tooltip
                                                            width: 300,
                                                        },
                                                    },
                                                }}
                                            >
                                                <HelpOutlineOutlinedIcon
                                                    sx={{
                                                        fontSize: 20,
                                                        color: '#667eea',
                                                        cursor: 'help',
                                                    }}
                                                />
                                            </Tooltip>

                                        </Box>
                                    </Button>
                                    <Collapse in={expandidoWhatsApp}>
                                        <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
                                            <Box sx={formTableSx}>
                                                <Typography sx={formLabelSx}>
                                                    Etapa para o Lead sem WhtasApp/incorreto:
                                                </Typography>
                                                <TextField
                                                    select
                                                    value={etapaWhatsApp}
                                                    onChange={(e) => !readonly && setEtapaWhatsApp(e.target.value)}
                                                    sx={{
                                                        flexGrow: 1,
                                                        maxWidth: '200px',
                                                        '& .MuiInputBase-root': {
                                                            height: '36px',
                                                            fontSize: '0.875rem'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            paddingTop: '8px',
                                                            paddingBottom: '8px'
                                                        }
                                                    }}
                                                >
                                                    {renderOpcoesEtapas()}
                                                </TextField>
                                            </Box>
                                            <Box sx={formTableSx}>
                                                <Typography sx={formLabelSx}>
                                                    Tag para o Lead sem WhtasApp/incorreto:
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, maxWidth: '400px', gap: 2, alignItems: 'center' }}>
                                                    <Tooltip
                                                        title="Use underscore (_) no lugar de espaços. Caracteres especiais não são permitidos."
                                                        open={erroTagWhatsApp}
                                                        arrow
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    fontSize: 14,
                                                                    bgcolor: '#d32f2f',
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <TextField
                                                            disabled={readonly}
                                                            value={tagWhatsApp}
                                                            onChange={(e) => {
                                                                const valor = e.target.value;
                                                                const temErro = validarTag(valor);
                                                                setErroTagWhatsApp(temErro);

                                                                if (!temErro && valor.length <= 25) {
                                                                    setTagWhatsApp(valor);
                                                                }
                                                            }}
                                                            onBlur={() => setErroTagWhatsApp(false)}
                                                            placeholder="Digite a tag"
                                                            inputProps={{ maxLength: 25 }}
                                                            error={erroTagWhatsApp}
                                                            sx={{
                                                                '& .MuiInputBase-root': {
                                                                    height: '36px',
                                                                    fontSize: '0.875rem'
                                                                },
                                                                '& .MuiSelect-select': {
                                                                    paddingTop: '8px',
                                                                    paddingBottom: '8px'
                                                                },
                                                                '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                    borderColor: '#d32f2f',
                                                                    borderWidth: '2px'
                                                                }
                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            mt: 0.5,
                                                            color: tagWhatsApp.length >= 25 ? '#d32f2f' : '#666',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        {tagWhatsApp.length}/25 caracteres
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {(mudancasWhatsApp && !readonly) && (
                                                <Button
                                                    onClick={() => {
                                                        setSecaoAtual("whatsapp");
                                                        setJustificativaSalvar("");
                                                        openDialogSalvar();
                                                    }}
                                                    sx={{
                                                        background: '#339e65ff',
                                                        mb: 1,
                                                        color: '#fff',
                                                        '&:hover': {
                                                            background: '#2d8757'
                                                        }
                                                    }}
                                                >
                                                    Salvar
                                                </Button>
                                            )}
                                        </Box>
                                    </Collapse>
                                </Box>

                                <Divider sx={{ my: 1.5 }} />

                                {/* Seção separada para Agendar Visita */}
                                <Box sx={{ pl: 2, pr: 2, pt: 2 }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    disabled={readonly}
                                                    checked={agendarVisitaCrm}
                                                    onChange={(e) => setAgendarVisitaCrm(e.target.checked)}
                                                    sx={{
                                                        '& .MuiSwitch-switchBase.Mui-checked': {
                                                            color: '#4caf50',
                                                        },
                                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                            backgroundColor: '#4caf50',
                                                        },
                                                        '& .MuiSwitch-switchBase': {
                                                            color: '#f44336',
                                                        },
                                                        '& .MuiSwitch-track': {
                                                            backgroundColor: '#f44336',
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Agendar visita no CV"
                                            labelPlacement="start"
                                            sx={{
                                                mb: 2,
                                                marginLeft: 0,
                                                display: 'flex',
                                            }}
                                        />
                                        <Tooltip
                                            title="Configure se o Agente pode agendar visitas no CV."
                                            arrow
                                            slotProps={{
                                                tooltip: {
                                                    sx: {
                                                        fontSize: 16, // tamanho da fonte do tooltip
                                                        width: 300,
                                                    },
                                                },
                                            }}
                                        >
                                            <HelpOutlineOutlinedIcon
                                                sx={{
                                                    fontSize: 20,
                                                    color: '#667eea',
                                                    cursor: 'help',
                                                    mt: 1,
                                                    ml: 2,
                                                }}
                                            />
                                        </Tooltip>
                                    </Box>

                                    {(mudancasAgendarVisita && !readonly) && (
                                        <Button
                                            onClick={() => {
                                                setSecaoAtual("agendarVisita");
                                                setJustificativaSalvar("");
                                                openDialogSalvar();
                                            }}
                                            sx={{
                                                background: '#339e65ff',
                                                mb: 1,
                                                color: '#fff',
                                                '&:hover': {
                                                    background: '#2d8757'
                                                }
                                            }}
                                        >
                                            Salvar
                                        </Button>
                                    )}
                                </Box>

                            </>

                        )}
                    </Paper>
                </Box>
            </Box>

            {/* DIALOG DE CONFIRMAÇÃO DE SALVAMENTO */}
            <Dialog
                open={dialogSalvarOpen}
                onClose={() => setDialogSalvarOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{
                    bgcolor: '#e3f2fd',
                    color: '#1976d2',
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}>
                    ⚠️ Confirmar Alteração
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
                        {getNomeUsuario()} tem certeza que deseja salvar estas alterações?
                    </Typography>
                    <Box sx={{
                        bgcolor: '#fff3e0',
                        p: 2,
                        borderRadius: 1,
                        border: '1px solid #ffcc80'
                    }}>
                        <Typography variant="body2" sx={{ color: '#e65100', fontWeight: 500 }}>
                            Esta ação irá afetar os parâmetros do agente no seu CRM.
                        </Typography>
                    </Box>
                    <TextField
                        disabled={readonly}
                        label="Justificativa da Alteração"
                        placeholder="Descreva o motivo desta alteração nos parâmetros..."
                        value={justificativaSalvar}
                        onChange={(e) => setJustificativaSalvar(e.target.value)}
                        fullWidth
                        multiline
                        rows={3}
                        required
                        sx={{ mt: 2 }}
                    />
                </DialogContent>
                <Box sx={{ p: 2, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => setDialogSalvarOpen(false)}
                        variant="outlined"
                        sx={{ textTransform: 'none' }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleSalvarParametros}
                        variant="contained"
                        endIcon={salvandoParametro ? <CircularProgress size={16} color="inherit" /> : <SendIcon />}
                        disabled={!justificativaSalvar.trim() || salvandoParametro}
                        sx={{
                            backgroundColor: '#1976d2',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                            },
                            '&:disabled': {
                                backgroundColor: '#e0e0e0',
                                color: '#9e9e9e',
                            },
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            px: 3,
                            py: 1
                        }}
                    >
                        {salvandoParametro ? 'Enviando...' : `Enviar`}
                    </Button>
                </Box>
            </Dialog>
        </>
    );
};

export default Parametros;

